import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function SuperCustomers() {
  const [list, setList] = useState([]);

  const load = async () => setList((await api.get("/admin/customers")).data);
  useEffect(() => { load(); }, []);

  const toggleBlock = async (id, blocked) => {
    try {
      await api.patch(`/admin/customers/${id}/block`, null, { params: { blocked } });
      toast.success(blocked ? "Customer blocked" : "Customer unblocked");
      load();
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-5">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Customers</h1>
        <p className="text-gray-600 text-sm">{list.length} customers</p>
      </div>

      <div className="qd-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500 border-b">
              <th className="p-3 font-semibold">Name</th>
              <th className="p-3 font-semibold">Mobile</th>
              <th className="p-3 font-semibold">Orders</th>
              <th className="p-3 font-semibold">LTV</th>
              <th className="p-3 font-semibold">Wallet</th>
              <th className="p-3 font-semibold">Status</th>
              <th className="p-3 font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} className="border-b border-gray-50">
                <td className="p-3 font-semibold">{c.name?.trim() || <span className="text-gray-400 italic">No name</span>}</td>
                <td className="p-3 font-mono text-xs">{c.mobile}</td>
                <td className="p-3">{c.order_count}</td>
                <td className="p-3 font-bold">₹{Math.round(c.lifetime_value)}</td>
                <td className="p-3">₹{c.wallet_balance}</td>
                <td className="p-3">
                  {c.is_blocked
                    ? <span className="text-xs px-2 py-1 rounded-full bg-red-50 text-red-700 font-bold">Blocked</span>
                    : <span className="text-xs px-2 py-1 rounded-full bg-green-50 text-green-700 font-bold">Active</span>}
                </td>
                <td className="p-3">
                  <button onClick={() => toggleBlock(c.id, !c.is_blocked)}
                    className={`text-xs px-3 py-1 rounded-full font-bold ${c.is_blocked ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}
                    data-testid={`customer-block-${c.mobile}`}>
                    {c.is_blocked ? "Unblock" : "Block"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
